import { render, staticRenderFns } from "./wiki_discussions_signed_out.vue.js?vue&type=template&id=5451e7a6&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_discussions_signed_out.vue?vue&type=template&id=5451e7a6&vue3"
import script from "./wiki_discussions_signed_out.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_discussions_signed_out.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_discussions_signed_out.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_discussions_signed_out.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports